import {Component, Vue } from "vue-property-decorator";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {Confirm} from "~/components/modals/confirm";
import {ButtonMainCreate} from "~/components/buttons/button-main-create";
import {ModalGroupEdit} from "~/modules/groups/components/modal-group-edit";
import {Group} from "~/lib/models/group";
import {getUsersManagementStore} from "~/modules/users/store";
import {User} from "~/lib/models/user";
import {Role} from "~/modules/users/lib/roles-utils";
import {DataTable} from "~/components/data-table";

const usersManagementStore = getUsersManagementStore();

@Component
export class UsersByGroupsList extends Vue {

  @usersManagementStore.Getter roles: Role[];
  @usersManagementStore.State users: User[];
  @usersManagementStore.State groups: Group[];
  @usersManagementStore.Action removeGroup;

  private editGroupTarget = null;
  private askRemoveGroup = false;
  private openCreateGroupModal = false;

  async doRemoveGroup(group){
    try {
      await this.removeGroup({ group });
      this.$notify.success("Le groupe a été supprimé");
    } catch (err){
      this.$notify.error("Erreur lors de la suppression");
    }
    this.editGroupTarget = null;
    this.askRemoveGroup = false;
  }

  get headers() {
    return [
      {
        key: 'group.label',
        value: grp => grp.label, label: "Nom du Groupe"
      },
      {
        key: 'usersCount',
        value: grp => grp.usersCount,
        label: "Nombre d'utilisateurs"
      },
      {
        key: 'actions',
        value: grp => {
          return (
            <Columns>
              <Column class="is-3">
                <button class="button is-small" onClick={() => {
                  this.editGroupTarget = grp;
                  this.openCreateGroupModal = true;
                }}>Modifier</button>
              </Column>
              <Column>
                <button class="button is-small is-danger" onClick={() => {
                  this.editGroupTarget = grp;
                  this.askRemoveGroup = true
                }}>Supprimer</button>
              </Column>
            </Columns>
          );
        },
        label: "Actions",
        sortable:false
      }
    ];
  }

  render() {
    return (
      <div>

        {this.groups.length === 0  ? <p>Aucun groupe</p> : <DataTable class="m-t-20" headers={this.headers} tableData={this.groups} /> }

        <ButtonMainCreate onClick={() => {
          this.editGroupTarget = new Group();
          this.openCreateGroupModal = true;
        }} dataTooltip="Créer un groupe"/>

        <Confirm
          isActive={this.askRemoveGroup}
          type="danger"
          onClose={() => this.askRemoveGroup = false}
          onConfirm={() => this.doRemoveGroup(this.editGroupTarget)}
        >Vous êtes sur le point de supprimer le groupe selectionné. Veuillez confirmer la suppression.
        </Confirm>

        {this.openCreateGroupModal && (
          <ModalGroupEdit
            group={this.editGroupTarget}
            isActive={this.openCreateGroupModal}
            onGroupSaved={() => {
              this.openCreateGroupModal = false;
            }}
            onCancel={() => this.openCreateGroupModal = false}
          />
        )}

      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7cee066f/users-groups-list.tsx" });